export const breakpoints = {
  sm: 375,
  md: 834,
  lg: 1024,
  xl: 1440
} as const
